export const colors = {
  gray: '#f7f7f7',
  red: '#DC3545',
  cyan: '#51bcda',
  blue: '#007bff',
  indigo: '#6610f2',
  purple: '#6f42c1',
  pink: '#e83e8c',
  orange: '#fd7e14',
  yellow: '#ffc107',
  green: '#28a745',
  teal: '#20c997',
  grayDark: '#343a40',
  white: '#fff',
  black: '#000000',
};
